import { insertIntoSupabase, selectFromSupabase, updateInSupabase } from "../helpers/supabase-api";

export function getBoards() {
  return selectFromSupabase("boards", "*").then(data => ({ data }));
}

/**
 * Create a new board
 * @param {object} boardData - object containing the board data
 */
export function createBoard(boardData) {
  return insertIntoSupabase("boards", boardData);
}

/**
 * Update a board
 * @param {string} id - board ID to update
 * @param {object} boardData - object of data to update
 */
export function updateBoard(id, boardData) {
  return updateInSupabase("boards", boardData, { id });
}
